import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Magnetic from './Magnetic';

function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const navItems = [
    { to: '/', label: 'Home' },
    { to: '/service', label: 'Service' },
    { to: '/company', label: 'Company' },
    { to: '/recruit', label: 'Recruit' },
    { to: '/contact', label: 'Contact' },
  ];

  return (
    <nav className={`site-nav ${scrolled ? 'scrolled' : ''}`}>
      <Link to="/" className="nav-logo">
        <img
          src="/images/PerfTech_logo_01.png"
          alt="PerfTech"
          style={{ filter: 'brightness(0) invert(1)' }}
        />
      </Link>

      <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
        {navItems.map((item) => (
          <li key={item.to}>
            <Magnetic>
              <Link
                to={item.to}
                className={location.pathname === item.to ? 'active' : ''}
              >
                {item.label}
              </Link>
            </Magnetic>
          </li>
        ))}
        {menuOpen && (
          <li>
            <button
              onClick={() => setMenuOpen(false)}
              style={{
                background: 'none',
                border: '1px solid rgba(200,165,90,0.3)',
                borderRadius: '3em',
                padding: '10px 40px',
                color: 'rgba(255,255,255,0.6)',
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: '14px',
                letterSpacing: '0.1em',
                cursor: 'pointer',
                marginTop: '20px',
              }}
            >
              Close
            </button>
          </li>
        )}
      </ul>

      <div
        className="nav-burger"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        <span />
        <span />
      </div>
    </nav>
  );
}

export default Navigation;
